var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateModel, } from "@musicaudienceexchange/toccata";
export const defaultLeadForm = [
    {
        order: 1,
        label: "Name",
        name: "name",
        placeholder: "First and last name...",
        required: true,
        type: "text",
    },
    {
        order: 2,
        label: "Email address",
        name: "email",
        placeholder: "john@email.com",
        required: true,
        type: "email",
    },
    {
        order: 3,
        label: "Phone number",
        name: "phone",
        required: true,
        type: "phone",
    },
    {
        order: 4,
        label: "Zip code",
        name: "zipcode",
        placeholder: "5-digit code...",
        required: true,
        type: "zipcode",
    },
    {
        order: 5,
        label: "I agree to share the above information with {artist} and Set.Live. <a href='https://set.live/privacy' target='_blank'>Privacy Policy</a>",
        name: "consent",
        required: true,
        type: "checkbox",
    },
];
export class Support extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Support.prototype, "disabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Support.prototype, "buttonText", void 0);
export class Vote extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Vote.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Vote.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Vote.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Vote.prototype, "actionText", void 0);
export class Catalog extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Catalog.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Catalog.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Catalog.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Catalog.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Catalog.prototype, "actionRepeatText", void 0);
export class SupportMessage extends Model {
}
__decorate([
    validator.IsNumber()
], SupportMessage.prototype, "id", void 0);
__decorate([
    validator.IsString()
], SupportMessage.prototype, "text", void 0);
export class Sponsor extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "actionCompleteText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sponsor.prototype, "actionUnavailableText", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(SupportMessage, { each: true })
], Sponsor.prototype, "messageOptions", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsArray()
], Sponsor.prototype, "removeOptions", void 0);
export class FormField extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], FormField.prototype, "order", void 0);
__decorate([
    validator.IsString()
], FormField.prototype, "label", void 0);
__decorate([
    validator.IsString()
], FormField.prototype, "name", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], FormField.prototype, "placeholder", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], FormField.prototype, "required", void 0);
__decorate([
    validator.IsString()
], FormField.prototype, "type", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], FormField.prototype, "highlight", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsArray()
], FormField.prototype, "options", void 0);
export class Encore extends Model {
}
Encore.defaults = {
    leadForm: defaultLeadForm,
    formTemplateId: "english",
};
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "caption", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "actionRepeatText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "actionCompleteText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "actionDisabledText", void 0);
__decorate([
    TransformValidateModel(FormField, { each: true }),
    validator.IsOptional()
], Encore.prototype, "leadForm", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "formTemplateId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Encore.prototype, "enableFanResults", void 0);
export class Tabs extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Tabs.prototype, "activeBackground", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Tabs.prototype, "activeText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Tabs.prototype, "inactiveBackground", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Tabs.prototype, "inactiveText", void 0);
export class Colors extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "header", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "headerActions", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "page", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "artist", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "venue", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "date", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "divider", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "body", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "caption", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "action", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "actionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "modalAction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "modalActionLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "modalSecondaryAction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "listTitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "listSubtitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "listDivider", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "progressBar", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Colors.prototype, "progressBarBackground", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Tabs)
], Colors.prototype, "tabs", void 0);
const DropShadowTypes = [
    "default",
    "shadow_strong",
    "shadow_diffuse",
    "white_strong",
    "white_diffuse",
];
export class Customizations extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Customizations.prototype, "bannerGradientOffset", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(DropShadowTypes),
    validator.IsString()
], Customizations.prototype, "bannerTextDropShadow", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Customizations.prototype, "bannerHeight", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Customizations.prototype, "disableImageBlur", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Customizations.prototype, "googleFontUrl", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Customizations.prototype, "headerFont", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Customizations.prototype, "bodyFont", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Support)
], Customizations.prototype, "support", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Catalog)
], Customizations.prototype, "vote", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Catalog)
], Customizations.prototype, "catalog", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Sponsor)
], Customizations.prototype, "sponsor", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Encore)
], Customizations.prototype, "encore", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Colors)
], Customizations.prototype, "colors", void 0);
//# sourceMappingURL=customizations.js.map